import React, { useState } from 'react';
import Modal from '../../Components/Modal';
import API from '../../Services/API';
import Button from '../../Components/Button/Button';
import { selectableDateRanges } from '../../Data/DateRanges';
import Form, { Select, Actions } from '../../Components/Form';
import { useNewWindow } from '../../Services/helpers';

const Export = ({isOpen, setIsOpen}) => {
    const [downloadUrl, setDownloadUrl] = useState(null);
    const newWindow = useNewWindow();

    const startExport = (data) => {
        return API.get('/payments/export', data).then(res => {
            setDownloadUrl(res.downloadUrl);
        });
    }

    const download = () => {
        newWindow(downloadUrl);
        setIsOpen(false);
    }

    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Export payments" dismissible>
        {downloadUrl === null && <Form data={{dateRange: 'thisMonth'}} onSubmit={startExport}>
            <Select name="dateRange" label="Date Range" options={selectableDateRanges} />
            <Actions submit={{label: 'Export'}} cancel />
        </Form>}
        {downloadUrl && <p className="text-center">
            <Button theme="primary" icon="CloudArrowDown" label="Download" onClick={() => download()} />
        </p>}
    </Modal>
}

export default Export;
